import Api from './Api'

const endpoint = 'channels'

export default class ChannelService extends Api {

    async all () {
        const response = await this.client.get(`${endpoint}/all`)
        if (response.data) {
            return response.data.map(s => {
                return {
                    value: s.id,
                    text: s.name,
                    hint: s.text_hint
                }
            })
        }
        throw new Error('No data')
    }
}